import { createEvent } from '@/app/event-stream';
import { resolve } from '@/app/container';
import { ObjectCompletedEvent, ObjectCompletedEventName } from '../events/object-completion-events';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';

export const dispatchObjectCompletedEvent = (objectId: string): void => {
  const event = createEvent<typeof ObjectCompletedEventName, ObjectCompletedEvent>(ObjectCompletedEventName, {
    id: objectId
  });

  const eventStream: EventStream = resolve<EventStream>(EventStreamSymbol);
  eventStream.dispatch(event);
};
